
export const downloadFlightTemplate = () => {
  const csvContent = `flight_number,organization_code,departure_city_code,arrival_city_code,aircraft_type_code,scheduled_departure,scheduled_arrival,status,status_reason,gate`;
  
  const blob = new Blob([csvContent], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'flight_upload_template.csv';
  a.click();
  window.URL.revokeObjectURL(url);
};
